export const API_VERSION = {
  V2: '2',
};

const URL = {
  ADD_CYCLE_META_FIELDS: '/cycles/:id/add-meta-fields',
  CHANGE_EMAIL: '/users/change-email',
  CHANNEL: '/controllers/:id/channels/:channel_id',
  CHANNEL_CURRENT_SCALING_APPLY_ALL: '/controllers/:id/channels/current-scaling/apply-all',
  CHART_PREFERENCE: '/chart-preferences/:id',
  CHART_PREFERENCES: '/chart-preferences',
  CHART_PREFERENCE_CYCLE: '/chart-preferences/cycles/:cycleId',
  CHECK_AUTH_FLOW: '/auth/check-flow',
  CHECK_EMAIL: '/auth/check-email',
  CHECK_MFA_CODE: '/auth/check-mfa-code',
  CONTRACT: '/contracts/:id',
  CONTRACT_META_FIELDS_SAVE_AS_CLIENT_DEFAULT: '/contracts/:id/meta-fields/save-as-client-default',
  CONTRACTS: '/contracts',
  CONTRACTS_LOCATION: '/contracts/locations/:locationId',
  CONTRACT_SCREENS: '/screens/contracts/:contractId',
  LOCATION_SCREENS: '/screens/locations/:locationId',
  CONTRACT_SCREENS_CYCLES: '/screens/contracts/:contractId/cycles',
  CONTRACT_DEFAULT_META_TAG: '/contracts/:id/default-meta-tags',
  CONTRACT_META_FIELDS: '/contracts/:id/meta-fields',
  CONTROLLER: '/controllers/:id',
  CONTROLLERS: '/controllers',
  CONTROLLERS_LOCATION: '/controllers/locations/:locationId',
  CONTROLLERS_ORGANIZATION: '/controllers/organizations/:organizationId',
  CONTROLLER_CALIBRATION_CERTIFICATE: '/calibration-certificates/:id',
  CONTROLLER_CALIBRATION_CERTIFICATES: '/calibration-certificates',
  CONTROLLER_CALIBRATION_CERTIFICATES_DELETE: '/calibration-certificates/:id',
  CONTROLLER_CALIBRATION_CERTIFICATES_EDIT: '/calibration-certificates/:id/edit',
  CONTROLLER_CHANNEL: '/controllers/:id/channels/:channel_num',
  CONTROLLER_CHANNEL_FAULTS: '/controllers/:id/channels/:channel_num/faults',
  CONTROLLERS_CHANNELS_FAULTS: '/controllers/channels/faults',
  CONTROLLER_CHANNELS: '/controllers/:id/channels',
  CONTROLLER_CHANNELS_CONSOLE_SETUP: '/controllers/:id/channels/console-setup',
  CONTROLLER_CHANNEL_COLORS: '/controllers/:id/channel-colors',
  CONTROLLER_FAULT_CONTROL: '/controllers/:id/faultcontrol',
  CONTROLLER_SETTINGS: '/controllers/:id/settings',
  CURRENT_USER: '/users/me',
  CYCLE: '/cycles/:id',
  CYCLE_DUPLICATE: '/cycles/:id/duplicate',
  CYCLE_LATEST_IOT: '/cycles/:id/latestiot',
  CYCLES: '/cycles',
  CYCLES_CONTRACT: '/cycles/contracts/:contractId',
  CYCLES_LOCATION: '/cycles/locations/:locationId',
  CYCLES_COUNT_BY_CONTRACT: '/cycles/contracts/:contractId/count',
  CYCLES_COUNT_BY_LOCATION: '/cycles/locations/:locationId/count',
  CYCLES_CONTRACT_IOT_LATEST: '/cycles/contracts/:contractId/iot/latest',
  CYCLES_LOCATION_IOT_LATEST: '/cycles/locations/:locationId/iot/latest',
  CYCLES_CONTRACT_SCREEN: '/cycles/contracts/:contractId/screens/:screenId',
  CYCLE_SCREEN: '/cycles/:id/screen',
  CYCLE_LOGS: '/cycles/:id/iot',
  CYCLE_LOGS_STREAM: '/cycles/:id/logsstream',
  CYCLE_META_FIELDS: '/cycles/:id/meta-fields',
  SAVE_META_FIELDS_AS_DEFAULT: '/cycles/:id/save-metafields-as-default',
  CYCLE_EXCLUDE_CHANNEL_NAMES: '/cycles/:id/exclude-report-channels',
  CYCLE_DEVICE_COLORS: '/cycles/:id/device-colors-report',
  LOAD_DEFAULT_TAGS: '/cycles/:id/load-default-meta-fields',
  UPDATE_DEFAULT_META_TAGS: '/contracts/:id/update-default-meta-tags',
  UPDATE_CYCLE_META_FIELDS: '/cycles/:id/update-meta-fields',
  CYCLE_PAUSE: '/cycles/:id/pause',
  CYCLE_SETTINGS: '/cycles/:id/settings',
  CYCLE_CHANNEL_SETTINGS: '/cycles/:id/channel-settings',
  CYCLE_DB_SETTINGS: '/cycles/:id/cycle-settings',
  CYCLE_IOT_SETTINGS: '/cycles/:id/cycle-settings/channels',
  CYCLE_DB_SETTINGS_STEPS: '/cycles/:id/cycle-settings/steps',
  CYCLE_PLANNED_RECIPE: '/cycles/:id/planned-recipe',
  CYCLE_SETTINGS_MODE: '/cycles/:id/settings/mode',
  CYCLE_START: '/cycles/:id/start',
  CYCLE_STOP: '/cycles/:id/stop',
  CYCLE_UNPAUSE: '/cycles/:id/unpause',
  CYCLE_ATTACHMENTS: '/cycles/:id/attachments',
  CYCLE_ATTACHMENT: '/cycles/:id/attachments/:attachmentId',
  CYCLE_PACKAGES: '/cycles/:id/packages',
  CYCLE_CHANNELS: '/cycles/:id/channels',
  DELETE_ORGANIZATION_LOGO: '/organizations/current/delete-logo',
  EMPTY_LOCATIONS: '/locations/empty',
  FORGOT_PASSWORD: '/auth/forgot-password',
  CONFIRM_PASSWORD_RESET: '/auth/confirm-password-reset',
  GENERATE_PDF: 'reports/generate-pdf',
  CUSTOM_CHANNEL_NAMES: '/reports/custom-channel-names',
  SAVE_CUSTOM_CHANNEL_NAMES: '/reports/save-custom-channel-names',
  UPDATE_REPORT_POSITIONS: 'reports/update-positions',
  UPDATE_REPORT_INCLUDED: 'reports/update-included',
  DELETE_REPORT_CYCLE: 'reports/:id/cycles/:cycleId',
  GET_CURRENT_ORGANIZATION: 'organizations/current',
  INVITE_MEMBER: '/members/invite',
  LOCATION: '/locations/:id',
  LOCATION_META_FIELDS: '/locations/:id/meta-fields',
  LOCATION_BY_CONTRACT: '/locations/:contract_id',
  LOCATIONS: '/locations',
  LOCATIONS_WITH_CYCLE_COUNT: '/locations/cycle-count',
  MEMBER: '/members/:id',
  RE_INVITE_MEMBER: '/members/:id/re-invite',
  RESET_MEMBER_PASSWORD: '/members/:id/reset-password',
  MEMBERS: '/members',
  NOTE: '/notes/:id',
  NOTES: '/notes',
  NOTE_LINKS: '/notes/:id/links',
  NOTE_LINK: '/notes/:id/links/:linkId',
  RECIPE: '/recipes/:id',
  RECIPES: '/recipes',
  PRE_HEAT_RECIPE: '/pre-heat-recipes/:id',
  PRE_HEAT_RECIPES: '/pre-heat-recipes',
  RECIPE_FROM_SCRATCH: '/recipes/fromscratch',
  RECIPE_STEP: '/recipes/:id/steps/:step_id',
  RECIPE_STEPS: '/recipes/:id/steps',
  RECIPE_STEPS_REORDER: '/recipes/:id/steps/reorder',
  REDEEM_INVITATION_CODE: '/auth/invitation-code',
  REFRESH_TOKEN_URL: 'auth/refresh',
  REMOVE_CYCLE_META_FIELDS: '/cycles/:id/remove-meta-field',
  REPORT_PAGES: '/reports/:cycleId',
  REPORT_META_FIELDS: '/reports/:id/meta-fields',
  REPORT_META_FIELDS_KEEP_DEFAULT: '/reports/:id/meta-fields/keep-default',
  REPORT_META_FIELDS_LOAD_DEFAULT: '/reports/:id/meta-fields/load-default',
  CYCLE_REPORT_PAGES: '/reports/:cycleReportId/pages',
  REPORT_CYCLE_ITEMS: '/reports/cycles/:cycleId/items',
  SCREEN: '/screens/:id',
  SCREEN_CYCLES: '/screens/:id/cycles',
  SCREEN_FULL_CYCLES: '/screens/:id/fullcycles',
  SCREENS: '/screens',
  SET_PASSWORD: '/auth/set-password',
  SIGN_IN: '/auth/sign-in',
  SIGN_OUT: '/auth/sign-out',
  TAKE_GRAPH_SCREENSHOT: '/reports/take-graph-screenshot',
  TAKE_MAIN_SCREENSHOT: '/reports/take-main-screenshot',
  UPDATE_CURRENT_ORGANIZATION: '/organizations/current/update',
  UPLOAD_AND_SPLIT_PDF: '/reports/upload-and-split',
  UPLOAD_ORGANIZATION_LOGO: '/organizations/upload-logo',
  USER: '/users',
  USER_CHANGE_PASSWORD: '/users/change-password',
  USER_PROFILE: '/users/:id',
  VERIFY_EMAIL: '/users/verify-email',
  VERIFY_MFA_TOKEN: '/auth/verify-mfa-token',
  APP_VERSION: '/version',
};

export default URL;
